import React from "react";
import { Link } from "react-router-dom";
import { Select } from "antd";

import CollapseHeader from "../../../../../core/common/collapse-header/collapse-header";
import { all_routes } from "../../../../router/all_routes";

import type { SelectOption } from "../types";

interface LeadsTransferHeaderProps {
  formOptions: SelectOption[];
  formValue?: string;
  onFormChange: (value: string) => void;
  companyOptions: SelectOption[];
  companyValue?: string | number;
  onCompanyChange: (value: string | number) => void;
  onTransferClick: () => void;
  onExportClick: () => void;
  transferDisabled?: boolean;
  exportDisabled?: boolean;
}

const filterOption = (input: string, option?: { label: string; value: any }) =>
  (option?.label ?? "").toString().toLowerCase().includes(input.toLowerCase());

const LeadsTransferHeader: React.FC<LeadsTransferHeaderProps> = ({
  formOptions,
  formValue,
  onFormChange,
  companyOptions,
  companyValue,
  onCompanyChange,
  onTransferClick,
  onExportClick,
  transferDisabled = false,
  exportDisabled = false,
}) => {
  return (
    <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
      <div className="my-auto mb-2">
        <h2 className="mb-1">Leads Transfer</h2>
        <nav>
          <ol className="breadcrumb mb-0">
            <li className="breadcrumb-item">
              <Link to={all_routes.adminDashboard}>
                <i className="ti ti-smart-home" />
              </Link>
            </li>
            <li className="breadcrumb-item">CRM</li>
            <li className="breadcrumb-item active" aria-current="page">
              Leads Transfer
            </li>
          </ol>
        </nav>
      </div>

      <div className="d-flex align-items-center ms-auto flex-wrap gap-2 mb-2">
        <Select
          showSearch
          filterOption={filterOption}
          style={{ width: 240, minHeight: 38 }}
          placeholder="Select Company"
          value={companyValue ?? undefined}
          onChange={onCompanyChange}
          options={companyOptions}
        />

        <Select
          showSearch
          filterOption={filterOption}
          style={{ width: 220, minHeight: 38 }}
          placeholder="Select Form"
          value={formValue || undefined}
          onChange={onFormChange}
          options={formOptions}
          notFoundContent="No forms"
        />
        <button
          type="button"
          className="btn btn-info d-flex align-items-center"
          onClick={onTransferClick}
          disabled={transferDisabled}
        >
          <i className="ti ti-repeat me-1" />
          Transfer Leads
        </button>
        <button
          type="button"
          className="btn btn-success d-flex align-items-center"
          onClick={onExportClick}
          disabled={exportDisabled}
        >
          <i className="ti ti-download me-1" />
          Export List
        </button>
        <div className="d-flex my-xl-auto right-content align-items-center flex-wrap">
          <div className="head-icons mb-0">
            <CollapseHeader />
          </div>
        </div>
      </div>
    </div>
  );
};

export default LeadsTransferHeader;
